import { listStudioAssets, readStudioAsset, saveStudioAsset } from '../services/studioCloud';
import { randomId } from '../utils/randomId';
let dbPromise;
function database() {
  if (!dbPromise) dbPromise = new Promise((resolve, reject) => {
    const request = indexedDB.open('hestia-hdri-library', 1);
    request.onupgradeneeded = () => {
      request.result.createObjectStore('assets');
      request.result.createObjectStore('catalogue', { keyPath: 'id' });
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => { dbPromise = undefined; reject(request.error); };
  });
  return dbPromise;
}
export async function localEnvironments() {
  const db = await database();
  return new Promise((resolve, reject) => {
    const request = db.transaction('catalogue').objectStore('catalogue').getAll();
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}
export async function listEnvironments() {
  const local = await localEnvironments();
  const cloud = await listStudioAssets('hdri');
  return [...new Map([...local, ...cloud.map((row) => row.metadata)].map((item) => [item.id, item])).values()];
}
export async function saveEnvironment(file) {
  if (!/\.hdr$/i.test(file.name) || !file.size || file.size > 64 * 1024 * 1024) throw new Error('Choose a Radiance .hdr file, up to 64 MB.');
  const { RGBELoader } = await import('three/examples/jsm/loaders/RGBELoader.js');
  const decoded = new RGBELoader().parse(await file.arrayBuffer());
  if (!decoded?.width || !decoded?.height || decoded.width * decoded.height > 33554432) throw new Error('Maximum HDRI resolution: 32 megapixels.');
  const item = { id: `custom:${randomId()}`, name: file.name, width: decoded.width, height: decoded.height };
  const db = await database();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(['assets', 'catalogue'], 'readwrite');
    tx.objectStore('assets').put(file, item.id); tx.objectStore('catalogue').put(item);
    tx.oncomplete = resolve; tx.onerror = () => reject(tx.error); tx.onabort = () => reject(tx.error);
  });
  await saveStudioAsset(item.id, 'hdri', file, item);
  window.dispatchEvent(new Event('hestia:hdri-changed'));
  return item;
}
export async function readEnvironmentBlob(id) {
  const db = await database();
  const local = await new Promise((resolve, reject) => {
    const request = db.transaction('assets').objectStore('assets').get(id);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
  if (local) return local;
  const cloud = await readStudioAsset(id);
  if (cloud) return cloud.blob;
  throw new Error('Custom HDRI is unavailable. Upload it again and select it in the job settings.');
}
